import script from "./Hero1.vue?vue&type=script&lang=ts&setup=true"
export * from "./Hero1.vue?vue&type=script&lang=ts&setup=true"

import "./Hero1.vue?vue&type=style&index=0&id=88402e72&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-88402e72"]])

export default __exports__